// @flow
import React from 'react';

import { PrimaryButton } from '../../presentational/buttons/PrimaryButton';

export const FetchAllButton = ({ onClick }) => (
  <PrimaryButton onClick={onClick} size="mini" text="Fetch All" />
);
